import React from "react";
import "../css/ActivitiesSection.css";
import { Link } from "react-router-dom";

const ActivitiesSection = () => {
  const activityImg = "./images/primary.jpg";

  return (
    <section className="activities-container">
      <div className="act-main-card">
        <div className="act-flex-layout">
          <div className="act-info-box">
            <div className="act-blue-header">
              <h2>Extracurricular Activities and Cocurricular Activities</h2>
            </div>

            <div className="act-content-body">
              <p className="act-desc-text">
                At Sahara, we believe that children benefit academically and
                personally when they are involved in both extracurricular and{" "}
                <span className="act-highlight">co-curricular activities</span>.
                Not only does this allow them to explore their interests and
                develop a passion for something outside of academics, but it
                also teaches them concepts of working as a team and good
                sportsmanship. We have a vast range of ECAs and CCAs to appeal
                to children of all interests and backgrounds. From swimming and
                tae-kwon-do to clay making and needlework, we have options that
                will appeal to nearly every student on our campus.
              </p>

              <Link to="/co-curricular" className="btn btn-primary">
                READ MORE <i>›</i>
              </Link>
            </div>
          </div>

          <div className="act-image-box">
            <img
              src={activityImg}
              alt="Students in sports activity"
              className="act-hero-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ActivitiesSection;